import type { V1ConsoleUser } from '../client'

export type SocialProvider = 'OAUTH_PROVIDER_GOOGLE' | 'OAUTH_PROVIDER_GITHUB'
export interface AuthResponse {
  user?: V1ConsoleUser
  token?: string
  isNewUser?: boolean
  outcome?: string | number
}

export class AuthResponseError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'AuthResponseError'
  }
}

// Check explicit outcomes first: an intermediate response must never establish
// frontend identity, even if an older backend also included a user or token.
export function authResponseKind(response: AuthResponse): 'authenticated' | 'verification' {
  if (response.outcome === 'AUTH_OUTCOME_VERIFICATION_REQUIRED' || response.outcome === 2)
    return 'verification'
  if (response.outcome && response.outcome !== 'AUTH_OUTCOME_UNSPECIFIED' && response.outcome !== 'AUTH_OUTCOME_AUTHENTICATED' && response.outcome !== 1)
    throw new AuthResponseError('Unsupported authentication outcome')
  if (response.user && response.token)
    return 'authenticated'
  if (response.user && !response.user.emailVerified && !response.token)
    return 'verification'
  throw new AuthResponseError('Authentication response is incomplete')
}

export function oauthNavigation(authorizationUrl: string | undefined): { url: string, state: string } {
  if (!authorizationUrl)
    throw new Error('Authentication URL is missing')
  const url = new URL(authorizationUrl)
  const local = url.hostname === 'localhost' || url.hostname === '127.0.0.1'
  const state = url.searchParams.get('state')
  if ((url.protocol !== 'https:' && !(local && url.protocol === 'http:')) || url.username || url.password || !state)
    throw new Error('Invalid authentication URL')
  return { url: url.href, state }
}
